module.exports = __webpack_public_path__ + "static/media/gift3.4930e86e.png";